import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

// Busqueda de tipos de documentos con cantidades
export const findDocumentsTypes = createAsyncThunk(
  "massNotifications/findDocumentTypes",
  async (arg, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const documentsTypes = state.utils.category;
      const createdAtFilter = state.massNotification.createdAtFilter;
      const idsDocumentsTypes = documentsTypes.map((documentType) => documentType.id);
      const { data } = await axiosInstance.post(
        `${api.baseURL}document/count-pending-document-type-detail`,
        {
          idDocumentType: idsDocumentsTypes,
          organization: state.userAuthentication.user?.sourceOrganization,
          startDate: createdAtFilter?.from ? createdAtFilter?.from : null,
          endDate: createdAtFilter?.to ? createdAtFilter?.to : null,
        }
      );
      const documentTypesList = data.documents.map((documentType: any) => {
        return {
          id: documentType.idDocument,
          name: documentsTypes.find(
            (documentTypeElement) => documentTypeElement.id === documentType.idDocument
          )?.name,
          documentCount: documentType.count,
          peopleCount: documentType.peoples,
        };
      });
      const finalList = documentTypesList.filter((element: any) => {
        if (element.documentCount > 0) {
          return true;
        }
        return false;
      });

      return finalList;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
